module.exports = __webpack_public_path__ + "images/etiquete_regen-3b8b68768053da84a27a3502f96a5218.svg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/etiquete_regen.svg
// module id = 53
// module chunks = 0 1